module.exports = __webpack_public_path__ + "static/media/mail-blue.33a9d71a.svg";